module.exports = __webpack_public_path__ + "static/img/h2.d9c455db.png";